import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UseCase } from '@digibricks/core';
import { Status } from '../../../domain';
import { CreateFileStorageMethod } from '../create-file-storage.input';
export var CREATE_AI_ATTACHMENT_FILES_USE_CASE = 'CREATE_AI_ATTACHMENT_FILES_USE_CASE';
export var CreateAiAttachmentFilesUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateAiAttachmentFilesUseCase, _UseCase);

  var _super = _createSuper(CreateAiAttachmentFilesUseCase);

  function CreateAiAttachmentFilesUseCase(fileStorageRepository, externalFileStorageRepository) {
    var _this;

    _classCallCheck(this, CreateAiAttachmentFilesUseCase);

    _this = _super.call(this);
    _this.fileStorageRepository = fileStorageRepository;
    _this.externalFileStorageRepository = externalFileStorageRepository;
    return _this;
  }

  _createClass(CreateAiAttachmentFilesUseCase, [{
    key: "getFileDtoFromFile",
    value: function getFileDtoFromFile(file) {
      var fileExtension = ".".concat(file.name.split('.').pop());
      return {
        fileExtension: fileExtension,
        fileSize: file.size,
        fileName: file.name.split('.')[0]
      };
    }
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var fileDto, newInput, createdFileStorageOrError, createdFileStorage, uploadedOrError, updatedStatusOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileDto = this.getFileDtoFromFile(input.file);
                newInput = _objectSpread(_objectSpread({}, input), {}, {
                  fileDto: fileDto,
                  method: CreateFileStorageMethod.SIGNED_URL
                });
                _context.next = 4;
                return this.fileStorageRepository.createAiAttachmentFile(newInput);

              case 4:
                createdFileStorageOrError = _context.sent;

                if (!createdFileStorageOrError.isFailure) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Result.fail(createdFileStorageOrError.error));

              case 7:
                createdFileStorage = createdFileStorageOrError.getValue();
                _context.next = 10;
                return this.externalFileStorageRepository.create(input.file, createdFileStorage.uploadUrl);

              case 10:
                uploadedOrError = _context.sent;

                if (!uploadedOrError.isFailure) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", Result.fail(uploadedOrError.error));

              case 13:
                _context.next = 15;
                return this.fileStorageRepository.updateFile({
                  id: createdFileStorage.id.toString(),
                  status: Status.uploaded
                });

              case 15:
                updatedStatusOrError = _context.sent;

                if (!updatedStatusOrError.isFailure) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", Result.fail(updatedStatusOrError.error));

              case 18:
                return _context.abrupt("return", Result.ok(createdFileStorage));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "validate",
    value: function validate(input) {
      var conversationId = input.conversationId;
      var guardCollections = [{
        argument: conversationId,
        argumentName: 'Conversation ID'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var resultOrError, results, _iterator, _step, file, singleFileInput, uploadResult, _uploadResult;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Validate conversation ID
                resultOrError = this.validate(input);

                if (!resultOrError.isFailure) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                if (!(input.files && input.files.length > 0)) {
                  _context2.next = 30;
                  break;
                }

                results = [];
                _iterator = _createForOfIteratorHelper(input.files);
                _context2.prev = 6;

                _iterator.s();

              case 8:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 19;
                  break;
                }

                file = _step.value;
                singleFileInput = _objectSpread(_objectSpread({}, input), {}, {
                  file: file
                });
                _context2.next = 13;
                return this.uploadFile(singleFileInput);

              case 13:
                uploadResult = _context2.sent;

                if (!uploadResult.isFailure) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("return", Result.fail(uploadResult.error));

              case 16:
                results.push(uploadResult.getValue());

              case 17:
                _context2.next = 8;
                break;

              case 19:
                _context2.next = 24;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](6);

                _iterator.e(_context2.t0);

              case 24:
                _context2.prev = 24;

                _iterator.f();

                return _context2.finish(24);

              case 27:
                return _context2.abrupt("return", Result.ok(results));

              case 30:
                if (!input.file) {
                  _context2.next = 39;
                  break;
                }

                _context2.next = 33;
                return this.uploadFile(input);

              case 33:
                _uploadResult = _context2.sent;

                if (!_uploadResult.isFailure) {
                  _context2.next = 36;
                  break;
                }

                return _context2.abrupt("return", Result.fail(_uploadResult.error));

              case 36:
                return _context2.abrupt("return", Result.ok([_uploadResult.getValue()]));

              case 39:
                return _context2.abrupt("return", Result.fail('No files provided'));

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 21, 24, 27]]);
      }));

      function buildUseCase(_x2) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreateAiAttachmentFilesUseCase;
}(UseCase);